export const timelineMessages = {
  date: {
    id: 'timeline.date',
    defaultMessage: 'Date',
  },
  status: {
    id: 'timeline.status',
    defaultMessage: 'Status',
  },
  updatedBy: {
    id: 'timeline.updatedBy',
    defaultMessage: 'Updated By',
  },
  load: {
    id: 'timeline.load',
    defaultMessage: 'Load',
  },
  quantity: {
    id: 'timeline.quantity',
    defaultMessage: 'Quantity',
  },
  description: {
    id: 'timeline.description',
    defaultMessage: 'Description',
  },
  pickupLocation: {
    id: 'timeline.pickupLocation',
    defaultMessage: 'Pickup Location',
  },
  consignee: {
    id: 'timeline.consignee',
    defaultMessage: 'Deliver To',
  },
  requestedPickupDate: {
    id: 'timeline.requestedPickupDate',
    defaultMessage: 'Requested Pickup Date',
  },
  requestedDeliveryDate: {
    id: 'timeline.requestedDeliveryDate',
    defaultMessage: 'Requested Delivery Date',
  },
  value: {
    id: 'timeline.value',
    defaultMessage: 'Value',
  },
  scheduledDate: {
    id: 'timeline.scheduledDate',
    defaultMessage: 'Scheduled Date',
  },
  completedDate: {
    id: 'timeline.completedDate',
    defaultMessage: 'Completed Date',
  },
  location: {
    id: 'timeline.location',
    defaultMessage: 'Location',
  },
  action: {
    id: 'timeline.action',
    defaultMessage: 'Status',
  },
}
